module.exports = __webpack_public_path__ + "img/iconhongbao.7d31f554.png";